import './style.scss'
import { useContext } from 'react'
import utility from 'src/utils/utility'
import UserContext from 'src/provider/state-manager/userProvider';
import { AdminHome, StudentHome, TeacherHome } from 'src/component/Home';
import { MemberTypeEnum } from 'src/model';


const Home: React.FC = () => {
    const { user } = useContext(UserContext)

    return (
        <div className='dashboard-home'>
            {user?.profile?.memberType === MemberTypeEnum.ADMIN ? <AdminHome user={user} /> : null}
            {user?.profile?.memberType === MemberTypeEnum.TEACHER ? <TeacherHome user={user} /> : null}
            {user?.profile?.memberType === MemberTypeEnum.STUDENT ? <StudentHome user={user} /> : null}
        </div>
    );
}

export default utility.routeData('home', 'Dashboard Home', <Home />)
